export default __webpack_public_path__ + "static/media/uid2-raw.9f7360ca.csv";